import React, { Suspense, lazy } from "react";
import Markup from "./markup/markup";

// Plugins Stylesheet
import "bootstrap/dist/css/bootstrap.min.css";

// Slick Carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// StyleSheet
import "./css/typography.css";
import "./css/shortcodes/shortcodes.css";
import "./css/style.css";
import "./css/color/color-1.css";

// Fonts
import "./vendors/fontawesome/css/font-awesome.min.css";
import "./vendors/flaticon/flaticon.css";
import "./vendors/line-awesome/css/line-awesome.min.css";
import "./vendors/themify/themify-icons.css";

// Tailwind (paso 3): SOLO utilidades, sin preflight — el reset global desarmaría la
// plantilla, que todavía sostiene 70 componentes. Ver src/styles/tailwind.css.
import "./styles/tailwind.css";

// Rediseño (Fase 1): Manrope self-host + base/reset al final para ganar la cascada
import "./styles/fonts.css";
import "./styles/base.css";

// Rediseño (Fase 2): primitivas visuales (capa de componentes)
import "./styles/components/buttons.css";
import "./styles/components/forms.css";
import "./styles/components/cards.css";
import "./styles/components/feedback.css";
import "./styles/components/navigation.css";
import "./styles/components/overlays.css";
import "./styles/components/header.css";
import "./styles/components/footer.css";
import "./styles/components/layout.css";
import "./styles/components/course-card.css";
import "./styles/components/home.css";

import AuthProvider from "./context/context";
import TrackingProvider from "./context/trackingContext";
import LanguageProvider from "./context/languageContext";
import MembershipProvider from "./context/membershipContext";
import IboProvider from "./context/iboContext";
import ProspectProvider from "./context/prospectContext";
import EcommerceProvider from "./context/ecommerceContext";

import { ConfigProvider } from "antd";

import antdTheme from "./theme/antdTheme";

// /__ui es SOLO desarrollo: se carga con import() dinámico para que ni el
// banco visual ni sus dependencias (@iconify/react, iconos Lucide, muestras
// de antd) entren al bundle de producción. Rollup no incluye chunks lazy
// que ninguna ruta enruta desde código no-dev.
const UIReview = lazy(() => import("./ui-review/UIReview"));

function App() {
  if (
    process.env.NODE_ENV === "development" &&
    window.location.pathname === "/__ui"
  )
    return (
      <ConfigProvider theme={antdTheme}>
        <Suspense fallback={null}>
          <UIReview />
        </Suspense>
      </ConfigProvider>
    );
  !Array.isArray(JSON.parse(localStorage.getItem("tracking"))) &&
    localStorage.removeItem("tracking");
  return (
    // antd 5 genera sus estilos en JS: en vez de perseguirlos con selectores, se le
    // pasan los tokens del sistema y los genera él. Ver src/theme/antdTheme.js.
    <ConfigProvider theme={antdTheme}>
    <div className="page-wraper">
      <EcommerceProvider>
        <ProspectProvider>
          <IboProvider>
            <LanguageProvider>
              <TrackingProvider>
                <AuthProvider>
                  <MembershipProvider>
                    <Markup />
                  </MembershipProvider>
                </AuthProvider>
              </TrackingProvider>
            </LanguageProvider>
          </IboProvider>
        </ProspectProvider>
      </EcommerceProvider>
    </div>
    </ConfigProvider>
  );
}

export default App;
